import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useGameCache } from './cache'
import { type GameCoverRemoveInput, type GameCoverRemoveSuccess } from '@terros/common'

export function useRemoveGameCover(): RemoveHookResponse<GameCoverRemoveInput> {
  const cache = useGameCache()
  const mutation = useTantalimMutation<GameCoverRemoveInput, GameCoverRemoveSuccess>({
    url: '/game/cover/remove',
  })

  async function remove(input: GameCoverRemoveInput): Promise<void> {
    await mutation.mutateAsync(input)
    cache.removeCover(input.gameId)
  }

  return mutationRemove(mutation, remove)
}
